// ProfilePage.tsx - Update to add Save Changes button in header for Password & Security tab
import React, { useState } from 'react';
import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { AccountDetails } from './AccountDetails';
import { PasswordSecurity } from './PasswordSecurity';
import { InvoiceDetails } from './InvoiceDetails';
import { PlansBilling } from './PlansBilling';
import { Button } from '@/components/common/Button';

export const ProfilePage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname.split('/').pop();
  const [savePasswordForm, setSavePasswordForm] = useState<(() => void) | null>(null);

  const tabs = [
    { id: 'account-details', label: 'Account Details' },
    { id: 'password-security', label: 'Password & Security' },
    { id: 'invoice-details', label: 'Invoice Details' },
    { id: 'plans-billing', label: 'Plans & Billing' },
  ];

  return (
    <div className="h-full bg-gray-100">
      {/* Page Header */}
      <div className="bg-white border-b border-gray-200">
        <div className="px-6 flex items-center justify-between">
          <div className="py-4">
            <h1 className="text-xl font-semibold text-gray-900">Profile</h1>
          </div>
          
          {currentPath === 'password-security' && (
            <Button 
              variant="primary"
              onClick={() => savePasswordForm && savePasswordForm()}
            >
              Save Changes
            </Button>
          )}
        </div>

        {/* Tabs */}
        <div className="px-6 flex items-center space-x-6">
          {tabs.map(tab => (
            <button
              key={tab.id}
              onClick={() => navigate(`/profile/${tab.id}`)}
              className={`
                pb-3 px-1 text-sm font-medium border-b-2 transition-colors
                ${currentPath === tab.id
                  ? 'text-blue-600 border-blue-600'
                  : 'text-gray-500 border-transparent hover:text-gray-700'
                }
              `}
            >
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Content */}
      <div className="p-0">
        <div className="max-w-full mx-auto">
          <Routes>
            <Route path="account-details" element={<AccountDetails />} />
            <Route path="password-security" element={<PasswordSecurity onSetSubmitCallback={setSavePasswordForm} />} />
            <Route path="invoice-details" element={<InvoiceDetails />} />
            <Route path="plans-billing" element={<PlansBilling />} />
            <Route path="*" element={<AccountDetails />} />
          </Routes>
        </div>
      </div>
    </div>
  );
};